const { Component } = Shopware;
const utils = Shopware.Utils;

Component.extend('acris-blog-group-create', 'acris-blog-group-detail', {

    beforeRouteEnter(to, from, next) {
        if (to.name.includes('acris.blog.group.create') && !to.params.id) {
            to.params.id = utils.createId();
            to.params.newItem = true;
        }

        next();
    },

    methods: {
        getEntity() {
            this.item = this.repository.create(Shopware.Context.api);
            this.item.active = true;
            this.item.breadcrumbPriority = 10;
        },

        createdComponent() {
            if (!Shopware.Store.get('context').isSystemDefaultLanguage) {
                Shopware.Store.get('context').resetLanguageToDefault();
            }

            this.$super('createdComponent');
        },

        saveFinish() {
            this.isSaveSuccessful = false;
            this.$router.push({ name: 'acris.blog.group.detail', params: { id: this.item.id } });
        },

        onClickSave() {
            this.isLoading = true;

            this.repository
                .save(this.item, Shopware.Context.api)
                .then(() => {
                    this.isLoading = false;
                    this.createNotificationSuccess({
                        title: this.$tc('acris-blog-group.detail.titleSaveSuccess'),
                        message: this.$tc('acris-blog-group.detail.messageSaveSuccess')
                    });
                    this.$router.push({ name: 'acris.blog.group.detail', params: { id: this.item.id } });
                }).catch(() => {
                    this.isLoading = false;
                    this.createNotificationError({
                        title: this.$tc('acris-blog-group.detail.titleSaveError'),
                        message: this.$tc('acris-blog-group.detail.messageSaveError')
                    });
                });
        }
    }
});
